<h1 id="tableLabel">Weather forecast</h1>

<p>This component demonstrates fetching data from the server.</p>
@if (userInfo) {
  <div>
    <ul>
      @for (m of userInfo.userMappings; track m) {
        <li>@if (m.organization && m.orgRole) {
          <span>{{m.organization.organizationName}} - {{m.orgRole.value}}</span>
        }</li>
      }
    </ul>
  </div>
}
@if (!claims) {
  <p><em>Loading...</em></p>
}

@if (claims) {
  <table class='table table-striped' aria-labelledby="tableLabel">
    <thead>
      <tr>
        <th>Type</th>
        <th>Value</th>
      </tr>
    </thead>
    <tbody>
      @for (c of claims; track c) {
        <tr>
          <td>{{ c.type }}</td>
          <td>{{ c.value }}</td>
        </tr>
      }
    </tbody>
  </table>
}
